import { Loader2, Sparkles } from "lucide-react";

import { Button } from "@/components/ui/button";
import { useConversationSession } from "@/hooks/use-conversation-session";

import { useCopilotDraft } from "./use-copilot-draft";

export function ComposerCopilot({
	personId,
	windowClosed,
}: {
	personId: number;
	windowClosed: boolean;
}) {
	const { session, draft } = useConversationSession(personId);
	const { generate } = useCopilotDraft({ personId, windowClosed });

	return (
		<div className="border-t border-primary/15 bg-primary-soft px-3 py-2">
			<div className="flex items-center gap-2">
				<Sparkles className="size-4 shrink-0 text-primary" />
				<textarea
					data-slot="direction-input"
					aria-label="Orientação para o copiloto"
					placeholder="Oriente o copiloto..."
					value={draft.direction}
					onChange={(event) => session.editDirection(event.target.value)}
					onKeyDown={(event) => {
						if ((event.ctrlKey || event.metaKey) && event.key === "Enter") {
							event.preventDefault();
							generate();
						}
					}}
					rows={1}
					className="max-h-24 min-h-9 min-w-0 flex-1 resize-none rounded-md border border-primary/15 bg-card/80 px-2.5 py-2 text-sm [field-sizing:content] focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
				/>
				<Button
					data-slot="suggest"
					size="sm"
					disabled={draft.suggesting || draft.sending}
					aria-busy={draft.suggesting}
					onClick={generate}
				>
					{draft.suggesting && <Loader2 className="animate-spin" />}
					{draft.suggesting && "Gerando..."}
					{!draft.suggesting && "Gerar resposta"}
				</Button>
			</div>
			{draft.suggestionError && (
				<p role="alert" className="mt-2 text-xs text-destructive">
					Não foi possível gerar a resposta. Tente de novo.
				</p>
			)}
		</div>
	);
}
